
// import Vue from 'vue'
import { Component, Watch } from "vue-property-decorator";
import baseUserContextPage from "./baseUserContextPage";
import { mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import { pagedList } from "@/models/pagedList";
import { categoryModel } from "@/models/categoryModel";
import { productModel, productType } from "@/models/productModel";
import { CustomerInfoModel } from "@/models/customerModels";
import { productSearchResult } from "@/models/productSearchModel";
import { facetModel } from "@/models/facetModel";
import domainService from "@/services/domainService";

import eventHub from "../eventHub";
import _, { forEach } from "lodash";
import { optionModel, optionValueModel, optionAndSingleValueModel, optionDaApplicareModel } from "@/models/optionModel";
import { sisasListiniModel } from "@/models/sisasPimListiniModel";
import { CategoryFavouriteViewModel } from "@/models/categoryFavouriteViewModel";
var Qs = require("qs");

@Component({
    computed: {
        ...mapGetters(["getSearchLayout"])
    },
    methods: {
        ...mapMutations(["setSearchLayout"]),
        ...mapActions(["updateUserFavourites"])
    }
})
export default class favoritesPage extends baseUserContextPage {
    setSearchLayout!: (layout: string | null) => void;
    updateUserFavourites!: () => void;
    getSearchLayout!: string;
    clickedOptionCode: string = null;

    get urlFilters(): any {
        var instance = this;
        var params = instance.$route.query;

        return params.filters != undefined && params.filters != null ? Qs.parse(params.filters) : {};
    }

    _searchKey: string = "";
    _facetsKey: string = "";
    categories: CategoryFavouriteViewModel[] = [];
    filters: optionModel[] = [];
    filtersForCategory: optionDaApplicareModel[] = [];
    showCustomerModal: boolean = false;
    showAddToCartModal: boolean = false;
    isLoadingProducts: boolean = false;
    isLoadingListini: boolean = false;
    isLoadingCategories: boolean = false;
    isSendRequest: boolean = false;
    list: pagedList<productModel> = new pagedList();
    facets: facetModel[] = [];
    facetsForCount: facetModel[] = [];
    selectedProduct: productModel = null;

    categoryId: string = "";

    showModalNewCategory: boolean = false;
    nameNewCategory: string = "";

    selectedCategoryToUpdate: CategoryFavouriteViewModel = {
        id: 0,
        code: "",
        displayOrder: 0,
        name: "",
        itemCount: 0
    };
    showModalEditCategory: boolean = false;

    get resultLayout(): string {
        return this.getSearchLayout;
    }
    setLayout(layout: string) {
        this.setSearchLayout(layout);
    }
    searchParams: any = {
        pageSize: 12,
        pageIndex: 0,
        orderField: "name",
        direction: "ASC",
        search: null,
        categoryId: null,
        filters: {}
    };
    @Watch("$route", { deep: true })
    onRouteChange(to, from) {
        var instance = this;
        // if (to.query.categoryId != from.query.categoryId)
        //   instance.filters.forEach(f =>
        //     f.values.forEach(o => (o.selected = false))
        //   );
        // debugger;
        //if (to.query.search != from.query.search)
        instance.filters.forEach((f) => f.values.forEach((o) => (o.selected = false)));
        instance.setQueryParams(to.query);
        this.fetchProducts();
    }

    get productsRows() {
        var instance = this;
        return _.chunk(instance.list.items, 3);
    }
    get productsList() {
        var instance = this;
        return instance.list.items;
    }
    get showCustomerDescription(): boolean {
        return this.categoryId != null && (this.isUserB2BAdmim || this.isUserRefEmployee || this.isUserEmployee);
    }
    get isCustomerSelected(): boolean {
        return this.getCurrentCustomer != null;
    }
    get isLoading() {
        // return this.isLoadingCategories || this.isLoadingProducts;
        return this.isLoadingProducts;
    }

    get showAvtiveFiltersRow(): boolean {
        var instance = this;
        return instance.activeFilters.length > 0;
    }
    get activeFilters() {
        var instance = this;
        if (instance.filters == null) return [];
        return instance.filters.filter((x) => x.values != null && x.values.find((o) => o.selected) != null);
    }
    get showFilters(): boolean {
        var instance = this;

        var fs = instance.filtersValid;
        return (fs != null && fs.length > 0) || instance.showAvtiveFiltersRow;
    }
    get filtersValid(): facetModel[] {
        var instance = this;
        if (instance.facets == null || instance.facets.length == 0) return [];

        var f = instance.facets.filter(
            (x) =>
                x.code != "CategoryId" &&
                x.code != "TOP" &&
                x.values != null &&
                Object.keys(x.values).find((v) => v != null && v != "" && v != "EMPTY_STRING" && x.values[v] != null && x.values[v] > 0) != null
        );
        return f;
    }
    getSelectedOptions(filter: optionModel) {
        var instance = this;
        if (filter.values == null) return [];
        return filter.values.filter((x) => x.selected);
    }
    getSearchParams() {
        var copy = Object.assign({}, this.searchParams);
        copy.customerId = this.getCurrentCustomerId;
        copy.categoryId = this.categoryId;
        return copy;
    }
    updateQueryParams(): void {
        var instance = this;
        var q = instance.getQueryParams();

        instance.$router.push({
            name: "favorites",
            query: q
        });
    }
    getQueryParams(): any {
        var instance = this;

        var hasFilters = instance.activeFilters.length > 0;
        if (hasFilters) {
            instance.searchParams.filters = {};
            instance.activeFilters.forEach((x) => {
                var selected = [];
                x.values.forEach((o) => {
                    if (o.selected) {
                        selected.push(o.code);
                    }
                });
                if (selected.length > 0) instance.searchParams.filters[x.code] = selected;
            });
        } else {
            instance.searchParams.filters = {};
        }

        var f = hasFilters ? Qs.stringify(instance.searchParams.filters) : undefined;
        var q = {
            page: instance.searchParams.pageIndex,
            search: instance.searchParams.search,
            filters: f == null || f == "" ? undefined : f
        };
        return q;
    }
    setQueryParams(params: any) {
        var instance = this;

        instance.searchParams.pageIndex = params.page;
        instance.searchParams.search = params.search;
        // instance.searchParams.categoryId = params.categoryId;
        instance.searchParams.filters = params.filters != undefined && params.filters != null ? Qs.parse(params.filters) : {};

        instance.filters.forEach((x) => {
            var selFilter = instance.searchParams.filters[x.code];
            if (x.values != null)
                x.values.forEach((o) => {
                    o.selected = selFilter != null && selFilter.indexOf(o.code) != -1;
                });
        });
    }
    pageChanged(page: number) {
        var instance = this;
        instance.searchParams.pageIndex = page;
        instance.updateQueryParams();
        instance.viewScrollOnTop();
    }

    onSelectCategoryBreadcrumb(c: categoryModel) {
        this.$router.push({ path: `/favorites` });
    }
    onSelectCategoryFilter(c: CategoryFavouriteViewModel) {
        var instance = this;

        this.categoryId = c.code;
        this.searchParams.pageIndex = 0;
        instance.updateQueryParams();
        this.fetchProducts();
    }

    onNewCategoryClick() {
        this.nameNewCategory = "";
        this.showModalNewCategory = true;
    }

    onDeleteCategoryClick(c: CategoryFavouriteViewModel) {
        var self = this;

        this.$bvModal
            .msgBoxConfirm(`Sei sicuro di voler eliminare la categoria "${c.name}"?`, {
                contentClass: "border-warning",
                headerBgVariant: "warning",
                title: "Attenzione",
                size: "md",
                buttonSize: "sm",
                okVariant: "warning",
                okTitle: "SI",
                cancelTitle: "NO",
                hideHeaderClose: false,
                centered: true
            })
            .then((value) => {
                if (value == true) {
                    self.isSendRequest = true;

                    axios
                        .delete(`/account/favourites/category/${c.id}`)
                        .then((res) => {
                            self.$notify({
                                title: "",
                                text: `La categoria "${c.name}" è stata eliminata con successo`,
                                type: "success",
                                group: "msg"
                            });
                            self.fetchCategories();
                            if (self.categoryId && self.categoryId == c.code) {
                                self.categoryId = "";
                                self.searchParams.pageIndex = 0;
                                self.updateQueryParams();
                                self.fetchProducts();
                            } else if (!self.categoryId) {
                                self.searchParams.pageIndex = 0;
                                self.updateQueryParams();
                                self.fetchProducts();
                            }

                            self.isSendRequest = false;
                        })
                        .catch((error) => {
                            console.error(error);
                            self.isSendRequest = false;
                        });
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    onEditCategory() {
        if (!this.selectedCategoryToUpdate || !this.selectedCategoryToUpdate || !this.selectedCategoryToUpdate.name || this.selectedCategoryToUpdate.name.length == 0) {
            this.$notify({
                title: "",
                text: "Selezionare la categoria da modificare",
                type: "error",
                group: "msg"
            });

            return;
        }

        this.isSendRequest = true;

        var self = this;

        axios
            .put<boolean>("/account/favourites/category", self.selectedCategoryToUpdate)
            .then((res) => {
                self.$notify({
                    title: "",
                    text: "La categoria è stata modificata",
                    type: "success",
                    group: "msg"
                });
                let oldCodeSelected = self.selectedCategoryToUpdate.code;
                let oldIdSelected = self.selectedCategoryToUpdate.id;

                self.closeModalEditCategory();
                self.fetchCategories().then((res) => {
                    if (self.categoryId && self.categoryId == oldCodeSelected) {
                        let editedCategory = self.categories.find((x) => x.id == oldIdSelected);
                        self.categoryId = editedCategory.code;
                    }
                });

                self.isSendRequest = false;
            })
            .catch((error) => {
                console.error(error);
                self.isSendRequest = false;
            });
    }

    onEditCategoryClick(c: CategoryFavouriteViewModel) {
        var category = this.categories.find((x) => x.id == c.id);

        this.selectedCategoryToUpdate = category;
        this.showModalEditCategory = true;
    }

    onAddDefaultCategory() {
        this.isSendRequest = true;

        var self = this;
        let request: CategoryFavouriteViewModel = {
            id: 0,
            code: "favourite-sisas",
            displayOrder: 0,
            name: "I miei preferiti",
            itemCount: 0
        };

        axios
            .post<boolean>("/account/favourites/category", request)
            .then((res) => {
                self.$notify({
                    title: "",
                    text: "La nuova categoria è stata aggiunta",
                    type: "success",
                    group: "msg"
                });
                self.closeModalNewCategory();
                self.fetchCategories();

                self.isSendRequest = false;
            })
            .catch((error) => {
                console.error(error);
                self.isSendRequest = false;
            });
    }

    onAddNewCategory() {
        if (!this.nameNewCategory || this.nameNewCategory.length == 0) {
            this.$notify({
                title: "",
                text: "Il nome della categoria è obbligatorio",
                type: "error",
                group: "msg"
            });

            return;
        }

        this.isSendRequest = true;

        var self = this;
        let request: CategoryFavouriteViewModel = {
            id: 0,
            code: "",
            displayOrder: 0,
            name: this.nameNewCategory,
            itemCount: 0
        };

        axios
            .post<boolean>("/account/favourites/category", request)
            .then((res) => {
                self.$notify({
                    title: "",
                    text: "La nuova categoria è stata aggiunta",
                    type: "success",
                    group: "msg"
                });
                self.closeModalNewCategory();
                self.fetchCategories();

                self.isSendRequest = false;
            })
            .catch((error) => {
                console.error(error);
                self.isSendRequest = false;
            });
    }

    closeModalNewCategory() {
        this.showModalNewCategory = false;
        this.nameNewCategory = "";
    }

    closeModalEditCategory() {
        this.showModalEditCategory = false;
        this.selectedCategoryToUpdate = {
            id: 0,
            code: "",
            displayOrder: 0,
            name: "",
            itemCount: 0
        };
    }

    onResetSearch() {
        var instance = this;
        instance.searchParams.search = null;
        instance.searchParams.pageIndex = 0;
        instance.filters.forEach((f) => f.values.forEach((o) => (o.selected = false)));
        instance.updateQueryParams();
    }

    onCustomerSelectedFromProducCard(customer: CustomerInfoModel) {
        var instance = this;
        instance.fetchListini();
    }
    onSelectCustomer(customer: CustomerInfoModel) {
        var instance = this;
        instance.setCurrentCustomer(customer);
        instance.showCustomerModal = false;
        // this.fetchProducts();
        instance.fetchListini().then((res) => {
            if (instance.selectedProduct != null) instance.showAddToCartModal = true;
        });
    }
    onSelectProduct(p: productModel) {
        var instance = this;
        instance.selectedProduct = p;
        if (instance.getCurrentCustomer == null) {
            instance.showCustomerModal = true;
        } else {
            instance.showAddToCartModal = true;
        }
    }
    get colSpan(): number {
        return 6;
    }
    get skus(): string[] {
        var instance = this;
        if (instance.list == null || instance.list.items == null || instance.list.items.length == 0) return [];

        var skus = [];

        instance.list.items.forEach((p) => {
            skus.push(p.sku);
            if (p.skus != null)
                p.skus.forEach((c) => {
                    skus.push(c.sku);
                });
        });

        return skus;
    }
    fetchListini(): Promise<boolean> {
        var instance = this;
        instance.isLoadingListini = true;

        return new Promise((resolve, reject) => {
            if (instance.skus != null && instance.skus.length > 0) {
                axios
                    .post<sisasListiniModel[]>("/product/listini", {
                        customerId: this.getCurrentCustomerId,
                        skus: instance.skus
                    })
                    .then((res) => {
                        if (res.data) {
                            instance.list.items.forEach((p) => {
                                p.listini = res.data.filter((x) => x.articolo == p.sku);
                                if (p.skus != null)
                                    p.skus.forEach((c) => {
                                        c.listini = res.data.filter((x) => x.articolo == c.sku);
                                    });
                            });
                        }
                        instance.isLoadingListini = false;
                        resolve(true);
                    })
                    .catch((error) => {
                        console.error(error);
                        instance.isLoadingListini = false;
                        reject(error);
                    });
            } else {
                resolve(false);
            }
        });

        // if (instance.skus != null && instance.skus.length > 0) {
        //   axios
        //     .post<sisasPimListiniModel[]>("/product/listini", {
        //       customerId: this.getCurrentCustomerId,
        //       skus: instance.skus
        //     })
        //     .then(res => {
        //       if (res.data) {
        //         instance.list.items.forEach(p => {
        //           p.listini = res.data.filter(x => x.articolo == p.sku);
        //           if (p.skus != null)
        //             p.skus.forEach(c => {
        //               c.listini = res.data.filter(x => x.articolo == c.sku);
        //             });
        //         });
        //       }
        //       instance.isLoadingListini = false;
        //     })
        //     .catch(error => {
        //       console.error(error);
        //       instance.isLoadingListini = false;
        //     });
        // }
    }

    async fetchCategories(): Promise<void> {
        var self = this;
        this.isLoadingCategories = true;

        return axios
            .get<CategoryFavouriteViewModel[]>("/account/favourites/category")
            .then((res) => {
                if (res && res.data && res.data.length) {
                    self.categories = res.data;
                } else {
                    self.onAddDefaultCategory();
                }

                self.isLoadingCategories = false;
            })
            .catch((err) => {
                console.error(err);
                self.isLoadingCategories = false;
            });
    }

    fetchProducts(): void {
        // if (!this.categoryId || this.categoryId.length == 0) {
        //     this.$notify({
        //         title: "",
        //         text: "Selezionare una categoria",
        //         type: "error",
        //         group: "msg"
        //     });

        //     return;
        // }

        var instance = this;
        instance.isLoadingProducts = true;
        var p = instance.getSearchParams();
        instance._searchKey = Date.now().toString();
        p.searchKey = instance._searchKey;
        p.addFacets = false;
        axios
            .get<productSearchResult>(`/account/favourites/search?`, {
                params: p
            })
            .then((res) => {
                if (res.data && res.data.searchKey == instance._searchKey) {
                    if (res.data.list.items.length == 0 && res.data.list.pageIndex > 0) {
                        instance.searchParams.pageIndex = res.data.list.pageIndex - 1;
                        instance.updateQueryParams();
                        instance.fetchProducts();
                    }
                    instance.list = res.data && res.data.list ? res.data.list : new pagedList();

                    instance.fetchListini();
                    instance.isLoadingProducts = false;
                }
            })
            .catch((error) => {
                console.error(error);
                instance.isLoadingProducts = false;
            });
    }

    get filtersList(): optionModel[] {
        var instance = this;
        if (instance.filters == null) return [];
        var forCategory = instance.filters.filter((x) => {
            return instance.filtersForCategory.find((c) => c.optionCode == x.code) != null;
        });
        return forCategory.sort((a, b) => {
            var ca = instance.filtersForCategory.find((c) => c.optionCode == a.code) || new optionDaApplicareModel();
            var cb = instance.filtersForCategory.find((c) => c.optionCode == b.code) || new optionDaApplicareModel();
            return (ca.displayOrder || Number.MAX_SAFE_INTEGER) != (cb.displayOrder || Number.MAX_SAFE_INTEGER)
                ? (ca.displayOrder || Number.MAX_SAFE_INTEGER) > (cb.displayOrder || Number.MAX_SAFE_INTEGER)
                    ? 1
                    : -1
                : a.name > b.name
                ? 1
                : -1;
        });
    }

    mounted() {
        var instance = this;
        instance.setQueryParams(instance.$route.query);
        instance.fetchCategories();
        instance.fetchProducts();
        eventHub.$on(eventHub.events.CURRENT_CUSTOMER_CHANGED, instance.fetchListini);
    }
    beforeDestroy() {
        this.updateUserFavourites();
    }

    get specificoId(): number {
        var instance = this;
        if (instance.searchParams.search && instance.list.totalCount == 1 && instance.list.items[0].type == productType.Configurable) {
            var p = instance.list.items[0];
            var params = instance.searchParams.search.split(" ") || [];

            var children = (p.skus || []).filter((x) => (params as Array<string>).find((p) => p == x.sku) != null);
            if (children && children.length == 1) {
                var p = children[0];
                return p.id;
            }
        }
        return null;
    }
    setFiltriSeRicercaPerSku() {
        var instance = this;
        if (instance.searchParams.search && instance.list.totalCount == 1 && instance.list.items[0].type == productType.Configurable) {
            var p = instance.list.items[0];
            var params = instance.searchParams.search.split(" ") || [];

            var children = (p.skus || []).filter((x) => (params as Array<string>).find((p) => p == x.sku) != null);
            if (children && children.length == 1) {
                var p = children[0];
                // gli sku figli sono prodotti light e non ho le varianti caricate
                // if (p.variantsValues) {
                //   console.log(p.variantsValues);
                //   for (const property in p.variantsValues) {
                //     console.log(`${property}: ${p.variantsValues[property]}`);
                //     debugger;
                //   }
                // }
            }
        }
    }
    get firstElementIndex(): number {
        if (this.list == null) return 0;
        var currentPage = this.list.currentPage || 1;
        var pageSize = this.list.pageSize || 0;
        return 1 + (currentPage - 1) * pageSize;
    }
    get lastElementIndex(): number {
        if (this.list == null || this.list.items == null) return 0;
        return this.firstElementIndex + this.list.items.length - 1;
    }
    get showFilterSearch(): boolean {
        return this.$route.query != null && this.$route.query.search != null && this.$route.query.search != "";
    }

    onRemoveFavoriteProduct() {
        this.fetchProducts();
        this.fetchCategories();
    }

    get selectedId(): string {
        return this.categoryId;
    }
}
